
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.797 11.195a2.932 2.932 0 00-.25-.914c-.13-.281-.341-.586-.633-.914L2.391 5.383c-.35.182-.61.388-.782.617-.166.23-.25.469-.25.719 0 .245.047.492.141.742.099.25.26.557.484.922.235.39.396.713.485.969.088.255.133.51.133.765 0 .396-.063.69-.188.883H.32v-.383c.209-.036.352-.091.43-.164.078-.073.117-.182.117-.328 0-.234-.117-.64-.351-1.219C.27 8.286.148 7.771.148 7.36c0-.968.61-1.796 1.829-2.484L.89 3.687a3.211 3.211 0 01-.563-.82 2.089 2.089 0 01-.172-.82c0-.24.052-.505.157-.797C.421.958.56.693.726.453h.476c.021.39.096.724.227 1 .13.276.33.57.601.883L4.97 5.719a9.975 9.975 0 01.453-1.54c.187-.489.388-.895.601-1.218-.364-.094-.632-.185-.804-.273a1.131 1.131 0 01-.399-.344.94.94 0 01-.133-.524c0-.52.102-.976.305-1.367h.469c.031.271.107.466.226.586.12.12.303.208.547.266l.57.133c.282.062.495.14.641.234.146.088.248.19.305.305.057.114.086.28.086.5 0 .213-.02.403-.063.57a2.703 2.703 0 01-.687.086c-.099 0-.203-.008-.313-.024-.307.49-.546.982-.718 1.477-.167.49-.25.901-.25 1.234 0 .292.034.537.101.735.073.192.198.385.375.578l.86.976c.265.302.448.573.546.813a2.004 2.004 0 01.032 1.476 3.77 3.77 0 01-.446.797h-.476z","fill":"currentColor"}})])
          )
        }
      }
    